// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1398":"5de59804","1833":"2435dedf","2447":"5de59804","8304":"b482df74"}[chunkId] + ".chunk.css";
};